import { render, staticRenderFns } from "./aptamer.vue?vue&type=template&id=40a1647a&scoped=true"
import script from "./aptamer.vue?vue&type=script&lang=js"
export * from "./aptamer.vue?vue&type=script&lang=js"
import style0 from "./aptamer.vue?vue&type=style&index=0&id=40a1647a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a1647a",
  null
  
)

export default component.exports